import React, { useEffect } from "react";

import { ReactComponent as CloseIcon } from "../../../../assets/svg/close.svg";
import { IActionLessons } from "../../../../state";

import styles from "./ActionModal.module.scss";

export interface IActionModalProps {
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  modalOpen: boolean;
  modalLesson: IActionLessons | null;
  handleSubmitRealization: (
    lesson_id: number,
    content: string,
    realization_id: number | null,
  ) => void;
  calling: boolean;
  refetch: () => void;
}

const ActionModal: React.FC<IActionModalProps> = ({
  setModalOpen,
  modalLesson,
  handleSubmitRealization,
  calling,
  refetch,
}) => {
  const [content, setContent] = React.useState<string>("");

  const isSubmitting = React.useRef(false);

  const handleSubmit = () => {
    if (!modalLesson || calling) return;
    isSubmitting.current = true;

    handleSubmitRealization(
      modalLesson.id,
      content,
      modalLesson.reflection_realization_reference?.realization_id || null,
    );
  };

  useEffect(() => {
    if (isSubmitting.current && !calling) {
      isSubmitting.current = false;
      refetch();
      setModalOpen(false);
    }
  }, [calling, refetch, setModalOpen]);

  useEffect(() => {
    if (modalLesson && modalLesson.reflection_realization_reference !== null) {
      setContent(modalLesson.reflection_realization_reference.content);
    }
  }, [modalLesson]);

  if (!modalLesson) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <button
          className={styles.closeButton}
          onClick={() => setModalOpen(false)}
        >
          <CloseIcon />
        </button>
      </div>
      <h1>
        行動してみて気づいたことや <br /> 思ったことを記録しよう!
      </h1>
      <textarea
        name=""
        id=""
        placeholder="テキストを入力してください。"
        value={content}
        onChange={e => setContent(e.target.value)}
        rows={6}
      />
      <div className={styles.titleWrapper}>
        <h2>{modalLesson?.title}</h2>
        {modalLesson.lesson_keyword && (
          <span>{modalLesson.lesson_keyword?.name}</span>
        )}
      </div>
      <div className={styles.reflectionWrapper}>
        <div className={styles.reflection}>
          <h2>行動宣言</h2>
          <p>
            {modalLesson?.answer?.contents?.[1]?.content
              ? modalLesson.answer.contents[1].content
              : "回答がありません"}
          </p>
        </div>
        <div className={styles.space} />
        <div className={styles.reflection}>
          <h2>授業で学んだこと</h2>
          <p>
            {modalLesson?.answer?.contents?.[0]?.content
              ? modalLesson.answer.contents[0].content
              : "回答がありません"}
          </p>
        </div>
      </div>
      <div className={styles.buttonWrapper}>
        <button onClick={handleSubmit} disabled={!content.trim() || calling}>
          保存
        </button>
      </div>
    </div>
  );
};

export default ActionModal;
